import { combineReducers } from "@reduxjs/toolkit";

import { sentRemindersListingReducer } from "./SentRemindersListingSlice";

export const remindersReducer = combineReducers({
  sentReminders: sentRemindersListingReducer,
});
